import { useMemo } from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import { Dialog } from "../../../components/Dialog";

type DialogProgressProps = {
  open: boolean;
  total: number;
  progress: number;
  text?: string;
};

function DialogProgress({
  open,
  total,
  progress,
  text = "contatos atualizado de",
}: DialogProgressProps) {
  const normalise = useMemo(() => {
    return ((progress - 0) * 100) / (total - 0);
  }, [progress, total]);

  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <Stack spacing={2} alignItems="center" justifyContent="center">
        <Typography>
          {progress} {text} {total}
        </Typography>
        <Stack
          flexDirection="row"
          width="100%"
          alignItems="center"
          justifyContent="space-between"
        >
          <LinearProgress
            sx={{ width: "90%" }}
            variant="determinate"
            value={normalise}
          />
          <Typography variant="subtitle2" color="text.secondary">{`${Math.round(
            normalise
          )}%`}</Typography>
        </Stack>
      </Stack>
    </Dialog>
  );
}

export default DialogProgress;
